import { render } from "./Terminal_statistics.vue?vue&type=template&id=b2a0e70e&scoped=true"
import script from "./Terminal_statistics.vue?vue&type=script&lang=js"
export * from "./Terminal_statistics.vue?vue&type=script&lang=js"

import "./Terminal_statistics.vue?vue&type=style&index=0&id=b2a0e70e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a0e70e"]])

export default __exports__